import { LoginAuthNamespace } from '@core/models/client';

export namespace LoginAuthApiNamespace {
  export class IN {
    userName: string = '';
    password: string = '';
    captchaToken: string = '';
    constructor(input: LoginAuthNamespace.IN) {
      this.userName = input.login;
      this.password = input.password;
      this.captchaToken = input.recaptchaToken;
    }
  }

  export class OUT {
    accessToken: string = '';
    expiresIn: number = 0;
    // login: string = '';
  }
}
